module.exports = "<div class=\"fa-3x text-center\">\r\n  <span class=\"fas fa-spinner fa-pulse\" aria-label=\"Lade Daten...\" aria-hidden=\"true\"></span>\r\n  <p>{{loadingText}}</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/visbos-core/loading/loading-data/loading-data.component.html
// module id = ./src/app/core/visbos-core/loading/loading-data/loading-data.component.html
// module chunks = main